import SettingsPopoverContent, { RenderCardProps } from 'modules/editor/components/Settings/SettingsPopoverContent';

import CeilingHeightTile from './CeilingHeightTile';
import CountryTile from './CountryTile';
import DisplayOptionsTile from './DisplayOptionsTile';
import UnitTile from './UnitTile';

const SettingsPopoverContentContainer = (props: RenderCardProps) => {
  return (
    <SettingsPopoverContent {...props}>
      <DisplayOptionsTile />
      <CeilingHeightTile />
      <CountryTile />
      <UnitTile />
    </SettingsPopoverContent>
  );
};

export default SettingsPopoverContentContainer;
